import React, { useEffect } from 'react';

import { EventName } from '../../../services/analytics/providers/analyticsProvider';
import AnalyticsService from '../../../services/analytics/analyticsService';
import WelcomeGated from './Welcome/WelcomeGated';

export type GatedOnboardingFlowProps = {
  // TODO
};

function GatedOnboardingFlow(props: GatedOnboardingFlowProps) {
  useEffect(() => {
    AnalyticsService.track(EventName.GATED_GET_STARTED_VISIT);
  }, []);

  return <WelcomeGated />;
}

export default GatedOnboardingFlow;
